import {OnboardingService} from '../../../core/services/onboarding.service';
import {StringHelper} from '../../../core/helpers/strings.helper';
import {CustomFormControl, CustomFormControlDefinition} from '../../../shared/utils/custom-form-control';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';
import {FormBuilder} from '@angular/forms';
import {Component, OnInit, inject} from '@angular/core';

@Component({
	selector: 'app-otp-input',
	templateUrl: './otp-input.component.html',
	styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent implements OnInit {
	form: any;
	modalCallback: any;
	otpResponse: any;
	submitting: boolean;
	errorMessage: any;
	successful: any;
	title = 'Verify Phone Number';
	otpControl: CustomFormControlDefinition;
	phoneNumber: any;
	showSuccess = false;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(
		private fb: FormBuilder,
		public modal: NzModalRef,
		private onboardingService: OnboardingService
	) {
		this.otpControl = new CustomFormControl()
			.isRequired()
			.maxLength(6)
			.type('password')
			.isOTP()
			.build();

		this.form = this.fb.group({
			otp: this.otpControl.formGroupControl,
		});
	}

	ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.modalCallback = this.modal.componentInstance.callback;
		this.otpResponse = this.modal.componentInstance.data.generatedOtpResponse;
		this.errorMessage = this.modal.componentInstance.data.errorMessage;
		this.successful = this.modal.componentInstance.data.successful;
		this.phoneNumber = this.modal.componentInstance.data.phoneNumber;
	}

	submitOtp() {
		this.modalCallback(this.form.value.otp);
	}

	validateOTP() {
		const body = {
			phoneNumber: this.phoneNumber,
			otp: this.form.value.otp
		};
		this.submitting = true;
		this.onboardingService.validateOTPV2(body).then(res => {
			this.submitting = false;
			this.modalCallback(res);
		}).catch(err => {
			const error = StringHelper.getErrorMessageHttpErrorResponse(err);
			this.submitting = false;
			this.errorMessage = error;
		});
	}

}

export interface OtpModalModel {
	generatedOtpResponse: any;
	errorMessage: string;
	passed: boolean;
	title: string;
}
